import request from '@/utils/request'

export function careerLists(data) {
    return request({
        url: '/api/career/career_lists',
        method: 'get',
        params: data
    })
}

export function careerDetail(data) {
    return request({
        url: '/api/career/career_detail',
        method: 'get',
        params: data
    })
}
